export enum AppTierTypeGq {
  NONE = 'NONE',
  BETA_BASIC = 'BETA_BASIC',
  BETA_CUSTOM = 'BETA_CUSTOM',
  FREE_TRIAL = 'FREE_TRIAL',
  BASIC = 'BASIC',
  CUSTOM = 'CUSTOM',
  SPONSORED = 'SPONSORED',
  VOXEL_SUPPORT = 'VOXEL_SUPPORT',
}
